import React, { useEffect } from 'react'; // <-- Import useEffect
import { Container, Box, Typography } from '@mui/material';

function PrivacyPolicy() {
  
  // --- SEO: TITLE & DESCRIPTION ---
  useEffect(() => {
    // 1. Set the specific title for this page
    document.title = "Privacy Policy | Christmas Lights Map";

    // 2. Update the meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', "Read the Privacy Policy for the Christmas Lights Map 2025. Learn how we collect, use, and protect your personal information.");
    }

    // 3. Cleanup: Reset title when leaving this page
    return () => {
      document.title = "Christmas Lights Map 2025";
    };
  }, []);
  // ---------------------------------------

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>

        <Typography variant="body1" paragraph>
          Last updated: November 2025
        </Typography>

        <Typography variant="body1" paragraph>
          This Privacy Policy describes Our policies and procedures on the collection, 
          use, and disclosure of Your information when You use the Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We collect information you provide directly to us when you register for an account. This includes:
        </Typography>
        <ul>
          <li>First Name and Surname (to display on your map pins)</li>
          <li>Email Address</li>
          <li>Username and a Hashed Password</li>
        </ul>
        <Typography variant="body1" paragraph>
          We also collect the addresses and any photos you voluntarily upload for your display.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use the information we collect to:
        </Typography>
        <ul>
          <li>Provide, maintain, and improve our Service.</li>
          <li>Process your registration and display your submissions on the map.</li>
          <li>Process your payments through our third-party provider.</li>
        </ul>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          Third-Party Services
        </Typography>
        <Typography variant="body1" paragraph>
          **Payments:** We use PayPal to process all payments. We do not collect or store any of your credit card or financial information. All payment data is handled directly by PayPal.
        </Typography>
        <Typography variant="body1" paragraph>
          **Analytics:** We may use third-party services like Google Analytics to understand how our Service is used.
        </Typography>
        <Typography variant="body1" paragraph>
          **Advertising:** We may use Google AdSense to display ads. Google may use cookies to serve ads based on your prior visits.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          Your Data Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to access, edit, or delete your personal information. You can manage your submissions, including editing addresses and deleting submissions, by visiting your "My Submissions" page.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, you can contact us at: support@termplanner.com.au
        </Typography>
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;